import { WithdrawalInstructionDetails } from './withdrawalInstructionDetails';

export default WithdrawalInstructionDetails;